import { EarlyAccessStateTypes, EarlyAccessCreateUserTypes } from './types';

/**
 * Sets the user email for Early Access
 * @param {string} email - The user's email address
 * @returns {Object} Action object with type and email
 */
export const setEarlyAccessEmail = email => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_UPDATE_EMAIL,
  email,
});

/**
 * Sets the loading state for Early Access request
 * @returns {Object} Action object with type
 */
export const setEarlyAccessLoading = () => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_IS_LOADING,
});

/**
 * Sets the error state for Early Access request
 * @returns {Object} Action object with type
 */
export const setEarlyAccessError = () => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_HAS_ERROR,
});

/**
 * Sets the success state for Early Access request
 * @returns {Object} Action object with type
 */
export const setEarlyAccessSuccess = () => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_IS_SUCCESS,
});

/**
 * Resets the Early Access error state
 * @returns {Object} Action object with type
 */
export const resetEarlyAccessError = () => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_RESET_ERROR,
});

/**
 * Sets the current step in the Early Access flow
 * @param {number} earlyAccessStep - The step number
 * @returns {Object} Action object with type and earlyAccessStep
 */
export const setEarlyAccessStep = earlyAccessStep => ({
  type: EarlyAccessStateTypes.EARLY_ACCESS_STEP,
  earlyAccessStep,
});

/**
 * Sets the current step in the Early Access create user flow
 * @param {number} earlyAccessCreateUserStep - The step number
 * @returns {Object} Action object with type and earlyAccessCreateUserStep
 */
export const setEarlyAccessCreateUserStep = earlyAccessCreateUserStep => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_STEP,
  earlyAccessCreateUserStep,
});
